const roles = {
    tp: [
        { value: "ROLE_SUPER_ADMIN", label: "Super Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST_ADMIN", label: "Analyst Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST", label: "Analyst", rolesCanSeeThis: [] },
        { value: "ROLE_THIRD_PARTY", label: "Contact Person", rolesCanSeeThis: [] }
    ],
    gd: [
        { value: "ROLE_SUPER_ADMIN", label: "Super Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST_ADMIN", label: "Analyst Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST", label: "Analyst", rolesCanSeeThis: [] },
        { value: "ROLE_EMPLOYEE", label: "Employee", rolesCanSeeThis: [] },
        { value: "ROLE_TASK_OWNER", label: "Task Owner", rolesCanSeeThis: [] }
    ],
    cm: [
        { value: "ROLE_SUPER_ADMIN", label: "Super Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST_ADMIN", label: "Analyst Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST", label: "Analyst", rolesCanSeeThis: [] },
        { value: "ROLE_EMPLOYEE", label: "Employee", rolesCanSeeThis: [] },
        { value: "ROLE_TASK_OWNER", label: "Task Owner", rolesCanSeeThis: [] }
    ],
    wb: [
        { value: "ROLE_SUPER_ADMIN", label: "Super Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST_ADMIN", label: "Analyst Admin", rolesCanSeeThis: [] },
        { value: "ROLE_ANALYST", label: "Analyst", rolesCanSeeThis: [] },
        { value: "ROLE_EMPLOYEE", label: "Employee", rolesCanSeeThis: [] },
        { value: "ROLE_TASK_OWNER", label: "Task Owner", rolesCanSeeThis: [] }
    ]
}
export const RoleOptions = (module) => {
    return roles[module];
}

